import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {UnidadeMedida} from "../../../domain/UnidadeMedida";

@Injectable()
export class UnidadeMedidaHttpService  extends AbstractHttpService<UnidadeMedida>{
    url = '/api/unidadeMedida';
}
